/**
 * チュートリアル進捗バナーディレクティブ
 * ダッシュボードで4ステップのチュートリアル進捗を表示
 */

angular.module('inspinia').directive('tutorialBanner', [
  '$state',
  '$modal',
  '$window',
  'tutorialService',
  'tutorialSystemDataService',
  function ($state, $modal, $window, tutorialService, tutorialSystemDataService) {
    return {
      restrict: 'E',
      templateUrl: `/manage/src/view/directive/project/tutorial/tutorial_banner.html?${new Date().getTime()}`,
      link: function (scope) {
        scope.showBanner = true;

        // 基本ステップが完了しているかどうか
        scope.areBasicStepsCompleted = function () {
          return (
            scope.tutorial &&
            scope.tutorial.steps &&
            scope.tutorial.steps.every(function (step) {
              return step.complete;
            })
          );
        };

        // ステップタイトルを取得
        scope.getStepTitle = function (index) {
          return tutorialSystemDataService.getSystemArrayValue(scope, 'array_tutorial_step_title', index);
        };

        // 追加ステップタイトルを取得
        scope.getAdvanceStepTitle = function (index) {
          return tutorialSystemDataService.getSystemArrayValue(scope, 'array_tutorial_advance_step_title', index);
        };

        // 追加ステップ説明を取得
        scope.getAdvanceStepDescription = function (index) {
          return tutorialSystemDataService.getSystemArrayValue(scope, 'array_tutorial_advance_step_description', index);
        };

        // 基本ステップへ遷移
        scope.goToStep = function (index) {
          const stateNames = tutorialSystemDataService.getSystemArray(scope, 'array_tutorial_step_state_name');
          if (stateNames && stateNames[index]) {
            $state.go(stateNames[index]);
          }
        };

        // 追加ステップのリンクを開く（完了ステータスは更新しない）
        scope.openAdvanceStepLink = function (index) {
          const urls = tutorialSystemDataService.getSystemArray(scope, 'array_tutorial_advance_step_href');
          if (urls && urls[index]) {
            $window.open(urls[index], '_blank');
          }
        };

        // バナーを閉じる（今後表示しない機能）
        scope.closeBanner = function () {
          scope.tutorial.never_view_flag = true;
          tutorialService.changeNeverViewFlag(scope, $modal);
        };

        // チュートリアルステップの機能権限があるか
        scope.hasStepAuthority = function (index) {
          const authorityArray = tutorialSystemDataService.getSystemArray(scope, 'array_tutorial_step_authority');

          if (!authorityArray || index < 0 || index >= authorityArray.length) return false;

          const authority = authorityArray[index];

          // 空文字列の場合は全員に権限があるとみなす
          if (authority === '') return true;

          return scope.checkAuthority(authority, scope.system.FUNCTION_PERMISSION_READ);
        };
      },
    };
  },
]);
